import { AddIcon, SettingsIcon } from "@chakra-ui/icons";
import { Button, ButtonGroup, useDisclosure } from "@chakra-ui/react";
import React from "react";
import { FaUserCircle } from "react-icons/fa";
import AddEditClientModal from "../Admin/AddEditClientModal";
import AddEditSOWModal from "../Admin/AddEditSOWModal";
import UserListModal from "../Admin/UserListModal";

const AdminQuickActions = () => {
  const {
    isOpen: isUserModalOpen,
    onOpen: onUserModalOpen,
    onClose: onUserModalClose,
  } = useDisclosure();

  const {
    isOpen: isClientModalOpen,
    onOpen: onClientModalOpen,
    onClose: onClientModalClose,
  } = useDisclosure();

  const {
    isOpen: isSOWModalOpen,
    onOpen: onSOWModalOpen,
    onClose: onSOWModalClose,
  } = useDisclosure();

  return (
    <>
      <ButtonGroup mx="auto" spacing={2}>
        <Button
          leftIcon={<AddIcon />}
          fontSize="xs"
          colorScheme="yellow"
          onClick={onClientModalOpen}
        >
          Add Client
        </Button>
        <Button
          leftIcon={<FaUserCircle />}
          fontSize="xs"
          colorScheme="yellow"
          onClick={onUserModalOpen}
        >
          Users
        </Button>
        <Button
          leftIcon={<SettingsIcon />}
          fontSize="xs"
          colorScheme="yellow"
          onClick={onSOWModalOpen}
        >
          Projects
        </Button>
      </ButtonGroup>

      {isUserModalOpen && (
        <UserListModal isOpen={isUserModalOpen} onClose={onUserModalClose} />
      )}
      {isClientModalOpen && (
        <AddEditClientModal
          isOpen={isClientModalOpen}
          onClose={onClientModalClose}
        />
      )}
      {isSOWModalOpen && (
        <AddEditSOWModal
          isOpen={isSOWModalOpen}
          onClose={onSOWModalClose}
          client={null}
          sow={null}
        />
      )}
    </>
  );
};

export default AdminQuickActions;
